import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import SelectAsync from 'react-select/async';
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { Button } from "reactstrap"
import NumberFormat from 'react-number-format';

export default class Working extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            month: 0,
            comId: 0
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/working/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    setMoth(e) {
        //this.state.month = e;
        this.setState({ month: e });
    }
    setBodyValue(id, field, value, idheader, type) {
        if (type === 1) {
        

            for (var i = 0; i < this.state.data.record.length; i++) {
                if (this.state.data.record[i].id === id) {
                    if (field === "dateEnd") {
                        let data = value.toString();
                        this.state.data.record[i][field] = data;
                    }
                    else {
                        this.state.data.record[i][field] = value;

                    }
                }

            }

        }
        else if (type === 2) {
            for (var i = 0; i < this.state.data.record.length; i++) {
                if (this.state.data.record[i].id === idheader) {
                    for (var j = 0; j < this.state.data.record[i].workingDetailDtos.length; j++) {
                        if (this.state.data.record[i].workingDetailDtos[j].id === id) {
                            this.state.data.record[i].workingDetailDtos[j][field] = value;
                        }
                    }

                }
            }
        }
        this.setState({ data: this.state.data });
    }


    loadDataCash() {
        setTimeout(() => {
            fetch("/api/v1/working/getworking?month=" + this.state.month)
                .then(response => response.json())
                .then(response => {
                    if (response.status == 1) {
                        this.setState({
                            data: response,
                            loading: false
                        })
                    }
                    else {
                        this.showErorrMessage(response.message);
                        this.setState({
                            loading: false
                        });
                    }
                   
                })
        }, 50);
    };
    getCompanyDetail(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/working/getcompanydetails/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.titleCompany +'/'+_record.codeCompany
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/working/save", {
            record: this.state.data,



        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/WokingDetails/'+data.woId
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    renderForm() {
        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block-head nk-block-head-lg wide-sm">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <NavLink className="back-to" to="/home/"><em className="icon ni ni-arrow-left"></em><span>داشبورد</span></NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="nk-block nk-block-lg">
                                    <div className="card card-bordered">

                                        <div className="card-inner">
                                            <div className="tab-content">
                                                <div className="tab-pane active" id="base">
                                                    <div className="card-inner p-0">

                                                        <div className="row">

                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">ماه</label>
                                                                    <div className="form-control-wrap">
                                                                        <select className="form-control" type="text" onChange={e => this.setMoth(parseInt(e.target.value))}>
                                                                            <option value="0">انتخاب ماه</option>
                                                                            <option value="1">فروردین</option>
                                                                            <option value="2">اردیبهشت</option>
                                                                            <option value="3">خرداد</option>
                                                                            <option value="4">تیر</option>
                                                                            <option value="5">مرداد</option>
                                                                            <option value="6">شهریور</option>
                                                                            <option value="7">مهر</option>
                                                                            <option value="8">آبان</option>
                                                                            <option value="9">آذر</option>
                                                                            <option value="10">دی</option>
                                                                            <option value="11">بهمن</option>
                                                                            <option value="12">اسفند</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">برای ایجاد کارکرد دکمه ثبت را بزنید</label>
                                                                    <div className="form-control-wrap">
                                                                        <div className="btn-wrap">
                                                                            <span className="d-none d-md-block"><button type="button" onClick={e => this.loadDataCash()} className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em>ثبت </button></span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-xxl-12">
                                    <div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">
                                            <div class="nk-block">
                                                <div class="card-inner-group">
                                                    {this.state.data.record.map((record, index) =>
                                                        <div class="card-inner border border-gray bg-lighter text-dark">
                                                            <div className="row g-gs">
                                                                <div className="col-xxl-3">
                                                                    <h6 className="title">
                                                                        نام پرسنلی:<span className="text-info">{record.personFullName}</span>
                                                                    </h6>

                                                                </div>
                                                                <div className="col-xxl-3">
                                                                    <SelectAsync
                                                                        defaultValue={record.companyDetailId > 0 ? [{ value: record.administrativeUnit, label: record.title }] : null}
                                                                        isMulti={false}
                                                                        placeholder="انتخاب ردیف پیمان/کارگاه"
                                                                        defaultOptions
                                                                        isSearchable
                                                                        loadOptions={this.getCompanyDetail}
                                                                        onChange={e => this.setBodyValue(record.id, 'companyDetailId', e.value, record.id, 1)}
                                                                    />

                                                                </div>

                                                            </div>
                                                            <br />

                                                            <div class="row g-3 border">

                                                                <div className="col-2">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">کارکرد</label>
                                                                        <div className="form-control-wrap">

                                                                            <NumberFormat thousandSeparator={true} className="form-control" type="text" value={record.countWorker} onChange={e => this.setBodyValue(record.id, 'countWorker', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))), record.id, 1)} />


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {record.workingDetailDtos.map((item, indexs) =>

                                                                    <div className="col-2">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">{item.title}</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" value={item.value} onChange={e => this.setBodyValue(item.id, 'value', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))), record.id, 2)} />


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {record.countWorker < (this.state.month>6?30:31) && record.countWorker !== 0 &&
                                                                    <div className="col-2">
                                                                        <div className="form-group">
                                                                            <label className="form-label">دلیل نقض کارکرد</label>
                                                                            <div className="form-control-wrap">
                                                                                <select className="form-control" type="text" value={record.typeDis} onChange={e => this.setBodyValue(record.id, 'typeDis', parseInt(e.target.value), record.id, 1)}>
                                                                                    <option value="1">عادی</option>
                                                                                    <option value="2">زایمان</option>
                                                                                    <option value="3">استعلاجی بدون حقوق</option>
                                                                                    <option value="4">مرخصی بدون حقوق</option>
                                                                                    <option value="5">ترک کار</option>

                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {record.typeDis === 5 &&
                                                                    <div className="col-2">
                                                                        <div className="form-group">
                                                                            <label className="form-label">تاریخ ترک کار</label>
                                                                            <DatePicker className="rmdp-mobile"
                                                                                value={record.dateEnd}

                                                                                style={{

                                                                                    height: "34px",

                                                                                    fontSize: "14px",
                                                                                    padding: "3px 10px"
                                                                                }}
                                                                                onChange={e => this.setBodyValue(record.id, 'dateEnd', e, record.id, 1)}
                                                                                mobileLabels={{
                                                                                    OK: "Accept",
                                                                                    CANCEL: "Close",
                                                                                }} calendar={persian}
                                                                                locale={persian_fa} />
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <br />

                                                            </div>








                                                        </div>

                                                    )}
                                                    {/*        {this.state.data.record. }*/}
                                                    <br />
                                                    <button className="btn btn-outline-success" type="submit" onClick={e => this.save(e)}>ثبت نهایی جداول مالیات</button>
                                                    <br />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <br />



                        </div>
                    </div>
                </div>
            </div>
        </form>
    }
    SetCheckedInInsu(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inInsu = this.state.data.record.inInsu.replace(f, "");
        if (v) this.state.data.record.inInsu += f;
    }
    IsCheckedInsu(f) {
        f = "[" + f + "]";
        return this.state.data.record.inInsu.includes(f);
    }
    SetCheckedInTax(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inTax = this.state.data.record.inTax.replace(f, "");
        if (v) this.state.data.record.inTax += f;
    }
    IsCheckedInTax(f) {
        f = "[" + f + "]";
        return this.state.data.record.inTax.includes(f);
    }
    SetCheckedInReward(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inReward = this.state.data.record.inReward.replace(f, "");
        if (v) this.state.data.record.inReward += f;
    }
    IsCheckedInReward(f) {
        f = "[" + f + "]";
        return this.state.data.record.inReward.includes(f);
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}